module.exports = __webpack_public_path__ + "web/img/integral_zh.8ba684d7.png";